import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
/* eslint-disable @repo/internal/react/no-clone-element */
import { Children, cloneElement, Component } from 'react';
import { css, jsx } from '@emotion/react';
var containerStyles = css({
  display: 'flex',
  borderBottom: "solid 2px ".concat("var(--ds-border, #dfe1e6)")
});
var Headers = /*#__PURE__*/function (_Component) {
  _inherits(Headers, _Component);
  var _super = _createSuper(Headers);
  function Headers() {
    _classCallCheck(this, Headers);
    return _super.apply(this, arguments);
  }
  _createClass(Headers, [{
    key: "render",
    value: function render() {
      return (
        // TODO: Determine whether proper `tr` elements can be used instead of
        // roles (DSP-11588)
        jsx("div", {
          css: containerStyles,
          role: "row"
        }, Children.map(this.props.children, function (header, index) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            cloneElement(header, {
              key: index,
              columnIndex: index
            })
          );
        }))
      );
    }
  }]);
  return Headers;
}(Component);
export { Headers as default };